import React from "react";
import { Stack } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, Pagination } from "swiper/modules";
import "swiper/css/pagination";
import "swiper/css";
import "swiper/css/navigation";

import "./HomeLocalExpertise.css";

export const HomeLocalExpertise = () => {
  const data = [
    {
      SupplierId: "1",
      link: "/destination/uae",
      ImagePath:
        "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/On-Ground%20Expertise/the%20dubai%20frame.webp",
      Title: "The Dubai Frame, UAE ",
      desc: "Standing 150 meters tall, this golden giant frames panoramic cityscapes and features a glass-floored sky bridge that dares your senses. ",
    },
    {
      SupplierId: "2",
      link: "/destination/india",
      ImagePath:
        "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/On-Ground%20Expertise/new%20delhi.webp",
      Title: "New Delhi, India ",
      desc: "Start your tour by walking through the grandeur of Mughal forts and take your foodie side in the chaos of Chandni Chowk’s spice-scented lanes. ",
    },
    {
      SupplierId: "3",
      link: "/destination/qatar",
      ImagePath:
        "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Local%20Expertise/Khor%20Al%20Adaid,%20Qatar.webp",
      Title: "Inland Sea (Khor Al Adaid), Qatar ",
      desc: "Dunes stretch all the way to the water, which is rare anywhere in the world. Most visits include a 4x4 desert drive, stops for photos, and time by the sea. ",
    },
    {
      SupplierId: "4",
      link: "/destination/malaysia",
      ImagePath:
        "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Local%20Expertise/Cameron%20Highlands,%20Malaysia.webp",
      Title: "Cameron Highlands, Malaysia ",
      desc: "Green hills covered in tea plantations, with a noticeably cooler climate. People usually visit for short stays, tea estate walks, and relaxed scenic drives. ",
    },
    {
      SupplierId: "5",
      link: "/destination/singapore",
      ImagePath:
        "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Local%20Expertise/Sentosa%20Island,%20Singapore.webp",
      Title: "Sentosa Island, Singapore ",
      desc: "Home to Universal Studios, beach clubs, and cable car access, this leisure island is also known for its beaches and integrated attractions. ",
    },
    {
      SupplierId: "6",
      link: "/destination/south-africa",
      ImagePath:
        "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Local%20Expertise/Cape%20Town,%20South%20Africa,.webp",
      Title: "Cape Town, South Africa",
      desc: "Nestled between the ocean and the towering Table Mountain, the city offers beautiful views from every angle. ",
    },
    {
      SupplierId: "7",
      link: "/destination/uganda",
      ImagePath:
        "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Local%20Expertise/Bwindi%20Impenetrable%20Forest,%20Uganda.webp",
      Title: "Bwindi Impenetrable Forest, Uganda",
      desc: "A UNESCO Site, Bwindi is home to nearly half of the world’s remaining mountain gorillas.",
    },
    {
      SupplierId: "8",
      link: "/destination/tanzania",
      ImagePath:
        "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/On-Ground%20Expertise/serengati%20national%20park.webp",
      Title: "Serengeti National Park, Tanzania ",
      desc: "Endless plains, moving herds, and some of Africa’s most iconic wildlife moments. The Serengeti remains central to any serious safari itinerary. ",
    },
  ];

  return (
    <div className="home-local standard-padding">
      <h1 className="heading mb-4">
        On-Ground Expertise Across Every Region
      </h1>

      <div className="home-local-wrapper"> {/* ✅ NEW WRAPPER */}

        <Swiper
          modules={[Navigation, Autoplay, Pagination]}
          spaceBetween={16}
          slidesPerView={3}
          navigation={{
            nextEl: ".custom-next",
            prevEl: ".custom-prev",
          }}
          pagination={{
            el: ".custom-pagination",
            clickable: true,
          }}
          autoplay={{ delay: 2500 }}
          breakpoints={{
            0: { slidesPerView: 1 },
            600: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          className="home-local-slider"
        >
          {data.map((d) => (
            <SwiperSlide key={d.SupplierId}>
              <div
                className="home-local-card"
                style={{ backgroundImage: `url(${d.ImagePath})` }}
              >
                <Stack className="home-local-card-div">
                  <div className="d-flex gap-2 align-items-center mb-2">
                    <h5 className="mb-0">{d.Title}</h5>
                    <a href={d.link}>
                      <img
                        src="/assets/home-yellow-arrow.svg"
                        alt="ICON"
                        style={{ width: "34px", height: "34px" }}
                      />
                    </a>
                  </div>
                  <p>{d.desc}</p>
                </Stack>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* ARROWS */}
        <div className="custom-prev">
          <img src="/assets/blue-icon1.svg" alt="Prev" />
        </div>
        <div className="custom-next">
          <img src="/assets/blue-icon2.svg" alt="Next" />
        </div>

        {/* DOTS */}
        <div className="custom-pagination"></div>

      </div>
    </div>
  );
};